/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentRoam {
    constructor(cscom) {
        if (!(this instanceof CurrentRoam)) {
            return new CurrentRoam(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/roam/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/roam/list', null, data);
    }

}
